import React, { Fragment } from 'react'
import {Logo, Counter, Login } from '../components'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { updateFilter, linkedinLogin } from '../modules/positions'
import { filteredSlection } from '../modules/selectors'

const NotSignedInText = () => <div>
  <p className="card-text linkedin-login">
     Thousands of Israeli talents have helped make billions of dollars out of advertisements, forex, gambling or porn. <br/>
      We thank them for their contribution to humanity!<br/><br/>
      It's time to move on.<br/>
      <br/>
      We are Aleph, a venture capital fund. Our sole interest and motivation is helping the companies we invest in to hire the best people. <br/><br/>
      Tell us who you are, so we can reach out with relevant opportunities at companies that do good for this world.<br/>
      Your details will be kept confidential until you grant us permission.
  </p>
</div>

const SignedInText = () => <div>
  <p className="card-text linkedin-login">
    Got it - we'll reach out upon relevant opportunities!<br/>
    Meanwhile, you can read <a href="https://aleph.vc/adtech-is-still-a-bad-place-for-israeli-engineers-to-work-488b2112e2ad">
     why Adtech is still a bad place for Israeli engineers to work.
    </a>
    
  </p>
</div>


const Exclusive = ({
  positions,
  locations,
  companies,
  roles,
  skills,
  updateFilter,
  linkedinLogin,
  filtering,
  filter: {
    skill,
    company,
    location,
    role
  },
  user,
  showLogin
}) => <div className="exclusive-body">
  <Fragment>
    <Logo/>
    <div className="row no-gutters">
      <div className="container">
        <div className="row no-gutters">
        </div>
      </div>
    </div>
  </Fragment>
  <div className="container">
    <div className="row">
    </div>
    <div className="row">
      <div className="col">
        <div className="mb-3">
          <div>
          </div>
           <div className="card-body">
              <p className="card-text linkedin-login">
                {user == null ? (
                  <NotSignedInText/>
                ): (
                  <SignedInText/>
                )}
              </p>

              {user == null && <Fragment>
                <Login
                  loginSuccessHandler={linkedinLogin}
                />
                <div className="col-12">
                  <Counter positions={positions} filter={{skill, company, location, role}} />
                </div>
                <center><small>You can also just drop a note at <a href="mailto:jobs@aleph.vc">jobs@aleph.vc</a>.</small></center>              
              </Fragment>}

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

const mapStateToProps = (state) => {
  const { positions: { filter } } = state
  return { ...state.positions, filter, positions: filteredSlection(state) }
}

const mapDispatchToProps = dispatch => bindActionCreators({ updateFilter, linkedinLogin }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Exclusive)



// WEBPACK FOOTER //
// ./src/pages/exclusive.js